module.exports = __webpack_public_path__ + "3c81f958a96ad4869379a1d66eb343b5.svg";